import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';
import { select, Store } from '@ngrx/store';
import { IAppState, ClosePopin } from '@app/store';
import { getAuthModalType } from '@app/core/user/store/reducers';

@Component({
  selector: 'vc-auth-button',
  templateUrl: './auth-button.component.html'
})
export class AuthButtonComponent {
  @Input() type: string;
  modalType: string;

  constructor(public dialog: MatDialog, private store: Store<IAppState>) {
    this.store.pipe(select(getAuthModalType)).subscribe(
      type => {
        this.modalType = type;
      },
      () => {}
    );
  }

  openDialog() {
    const config: any = {
      disableClose: false,
      maxWidth: 1280,
      ariaLabelledBy: 'acc-dialogHeading',
      role: 'dialog',
      data: {
        type: this.type,
        forced: false
      }
    };
    this.dialog
      .open(AuthModalComponent, config)
      .afterClosed()
      .subscribe(
        () => {
          this.store.dispatch(new ClosePopin({ name: this.modalType }));
        },
        err => {}
      );
  }
}
